export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const DEFAULT_ROLE = 'DEFAULTROLE';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
export const ID_TOKEN = 'ID_TOKEN';
